module.exports = __webpack_public_path__ + "img/empty-brandbranch-selection.7637a388.png";